import { getFontSize } from '../../../../constants/fontSizes';

export const aboutSectionStyles = {
  container: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    height: 'auto',
    overflow: 'hidden',
    backgroundColor: '#00443F',
  },
  noiseOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
    pointerEvents: 'none',
    opacity: 1,
  },
  villaImage: {
    position: {xs: "relative", lg: "absolute"},
    bottom: {xs: "auto", lg: "-5%"},
    left: {xs: "auto", lg: "10%"},
    width: {xs: "100%",lg: "100%"},
    minHeight: {xs: "40vh", lg: "100%"},
    objectFit: 'cover',
    zIndex: 2,
    marginTop: {xs: "50px", lg: 0},
    marginBottom: {xs: "-10px", lg: 0},
  },
  textContainer: {
    marginTop: {xs: "20%", lg: "10%"},
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    zIndex: 3,
    position: 'relative',
    maxWidth: {xs: "100%", lg: "50%", xl: "40%"},
  },
  header: {
    fontSize: getFontSize(25),
    fontWeight: 700,
    fontFamily: 'Aurora',
    color: 'secondary.main',
    zIndex: 3,
  },
  title: {
    fontSize: getFontSize(80),
    fontWeight: 700,
    fontFamily: 'Aurora',
    color: 'secondary.main',
    marginBottom: '32px',
    zIndex: 3,
    lineHeight: {xs: "32px", md: "50px", lg: "75px", xl: "85px"},
  },
  description: {
    fontSize: getFontSize(18),
    fontWeight: 400,
    fontFamily: 'Lato',
    color: 'secondary.main',
    zIndex: 3,
  },
  button: {
    width: {xs: '150px', lg: '180px'},
    height: {xs: '50px', lg: '62px'},
    borderRadius: '52px',
    padding: {xs: '6px 8px', lg: '21px 44px'},
    marginTop: '32px',
    zIndex: 10,
    position: 'relative',
    cursor: 'pointer',
    pointerEvents: 'auto',
    textTransform: 'none',
    fontFamily: 'Lato',
    color: 'primary.main',
    fontSize: getFontSize(18),
    fontWeight: 700,
  },
  fadeInImage: (isVisible) => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(100px)',
    transformOrigin: 'center bottom',
    transition: 'opacity 1.2s ease-out, transform 1.2s ease-out',
  }),
  fadeInText: (isVisible) => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(100px)',
    transformOrigin: 'center bottom',
    transition: 'opacity 1.2s ease-out, transform 1.2s ease-out',
  }),
};

